"use strict";

/**
 * Shared Wave Borders JavaScript
 * 
 * Applies SVG clip-path to blocks with wave borders
 * 
 * @param {string} blockSelector CSS selector for blocks with waves (e.g., '.alternating-50-50-block--has-waves')
 */

// Debug: Verify this file is loading
// console.log('wave-borders.js loaded');

function initWaveClipPaths(blockSelector) {
  var blocksWithWaves = document.querySelectorAll(blockSelector);

  // console.log('initWaveClipPaths called with selector:', blockSelector);
  // console.log('Found blocks with waves:', blocksWithWaves.length);

  blocksWithWaves.forEach(function (block, index) {
    var blockId = block.id;
    console.log("Block ".concat(index + 1, " - ID:"), blockId);
    if (blockId) {
      // Check if the SVG clip-path exists before applying
      var clipPathId = "wave-clip-".concat(blockId);
      var clipPathElement = document.querySelector("#".concat(clipPathId));

      // console.log(`Looking for clipPath with ID: ${clipPathId}`, clipPathElement ? 'Found!' : 'Not found');

      if (clipPathElement) {
        // Apply the clip-path using the block's unique ID
        block.style.clipPath = "url(#".concat(clipPathId, ")");
        block.style.webkitClipPath = "url(#".concat(clipPathId, ")"); // Safari support

        // Add class to SVG element (parent of clipPath) so CSS can target it
        var svgElement = clipPathElement.closest('svg');
        if (svgElement) {
          svgElement.classList.add('wave-clip-path');
          // console.log('Added wave-clip-path class to SVG element');
          // } else {
          //   console.log('SVG element not found for clipPath');
        }

        // Also add class to block element so CSS can target it
        block.classList.add('wave-clip-path');
        // console.log('Added wave-clip-path class to block element:', block);
        // } else {
        //   console.log(`ClipPath element not found for ID: ${clipPathId}`);
      }
      // } else {
      //   console.log(`Block ${index + 1} has no ID`);
    }
  });
}

/**
 * Initialize wave borders for a specific block type
 * 
 * @param {string} blockSelector CSS selector for blocks with waves
 */
function initWaveBorders(blockSelector) {
  // Initialize on DOM ready, with a small delay to ensure SVG is in DOM
  function initialize() {
    initWaveClipPaths(blockSelector);
    // Also try again after a short delay in case SVG loads async
    setTimeout(function () {
      return initWaveClipPaths(blockSelector);
    }, 100);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
}